/** In-app / socket notification types for Significant→critical threshold alerts. */
export const THRESHOLD_ALERT_TYPES = new Set([
  'threshold_alert',
  'critical_alert',
  'significant_alert',
  'alert_critical',
]);

export const isCriticalSeverity = (severity) => {
  const value = String(severity || '').toLowerCase();
  return value === 'significant' || value === 'critical';
};

export const isThresholdAlertNotification = (notification) => {
  if (!notification || typeof notification !== 'object') return false;
  const type = String(notification.type || notification.category || '').toLowerCase();
  if (THRESHOLD_ALERT_TYPES.has(type)) return true;
  if (isCriticalSeverity(notification.severity)) return true;
  return false;
};

/**
 * Normalize socket payload from `notification:new` or `alert:critical`.
 * Returns null when the event is unrelated (e.g. access_request).
 */
export const extractCriticalAlertInfo = (detail) => {
  if (!detail || typeof detail !== 'object') return null;

  const eventType = String(detail.type || '').toLowerCase();
  const nested =
    (detail.notification && typeof detail.notification === 'object' && detail.notification)
    || (detail.alert && typeof detail.alert === 'object' && detail.alert)
    || null;

  if (eventType === 'alert:critical' || eventType === 'alert_critical') {
    return buildAlertInfo(detail, nested);
  }

  // notification:new — only threshold/critical shaped payloads
  const candidate = nested || detail;
  if (!isThresholdAlertNotification(candidate) && !isCriticalSeverity(detail.severity)) {
    return null;
  }

  return buildAlertInfo(detail, nested || candidate);
};

const buildAlertInfo = (detail, nested) => {
  const bridgeName =
    detail.bridgeName
    || detail.bridge?.name
    || nested?.bridgeName
    || nested?.bridge?.name
    || detail.data?.bridgeName
    || nested?.data?.bridgeName
    || 'your bridge';

  const severity = String(
    detail.severity
    || nested?.severity
    || 'critical'
  ).toLowerCase();

  const alertId =
    detail.alertId
    || detail._id
    || nested?._id
    || nested?.alertId
    || `${bridgeName}-${detail.sensorId || nested?.sensorId || ''}-${detail.timestamp || nested?.timestamp || Date.now()}`;

  return {
    bridgeName,
    alertId: String(alertId),
    severity,
    sensorSerialNo: detail.sensorSerialNo || nested?.sensorSerialNo || '',
  };
};

export const formatCriticalAlertToast = (bridgeName) =>
  `Significant threshold alert for ${bridgeName || 'your bridge'} — notifications sent`;
